import React, { useContext, useState } from "react";
import { Row, Col, Modal, Container } from "react-bootstrap";
import {
  LoginFormContext,
  userCookieContext,
  userTokenContext,
  FormContextSignUP,
  FormContextForgetPass,
  LangContext,
} from "../../../App";
import "./Login.css";
import originallogo1 from "../../../Assets/Images/logo.png";
import originallogo2 from "../../../Assets/Images/logo.png";
import Field from "../../../Components/Fields/Fields";
import { Inputs, Validation, config } from "./config.js";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_ENDPOINT } from "../../../AppConfig";
import cookie from "react-cookies";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
import SignUpForm from "../SignUp/SignUp";
import ForgetPass from "../ForgetPassword/Phonenumber";
import string from "../../../Assets/Localization/Local";

const Login = (props) => {
  const { lang } = useContext(LangContext);
  const { ToggleLoginForm } = useContext(LoginFormContext);
  const { openFormSignUp, ToggleForm_signUp } = useContext(FormContextSignUP);
  const { openFormForgetPass, ToggleForm_forgetPass } = useContext(
    FormContextForgetPass
  );
  const { handleUserCookie } = useContext(userCookieContext);
  const { handleUserToken } = useContext(userTokenContext);
  const [show, setShow] = useState(true);

  const dimButton = {
    width: "100%",
    padding: "5px",
    borderRadius: "36px",
    margin: "0 auto",
    outline: "none",
    border: "none",
    fontSize: "16px",
    fontWeight: "600",
    backgroundColor: "#171717",
  };
  const btnLoginStyle = {
    width: "70%",
    padding: "13px",
    borderRadius: "10px",
    margin: "0 auto",
    outline: "none",
    border: "none",
    backgroundColor: "#171717",
    fontSize: "16px",
    fontWeight: "600",
  };
  const AuthPostAxios = (data) => {
    axios
      .post(`${API_ENDPOINT}/socialMedia`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Post Req Login :", response.data)
        cookie.save("CatchItUser", response.data.user, { path: "/" });
        cookie.save("CatchIt_token", response.data.token, { path: "/" });
        handleUserCookie();
        handleUserToken(response.data.token);
        ToggleLoginForm();
      })
      .catch((error) => {
        console.log("Error Login :", error.response)
      });
  };
  const responseFacebook = (response) => {
    // console.log("FaceBook Response ===>", response);
    if (response.picture) {
      let obj = {
        // image: response.picture.data.url,
        name: `${response.first_name} ${response.last_name}`,
        // email: response.email,
        socialId: response.id,
        socialMediaType: "FACEBOOK",
      };

      AuthPostAxios(obj);
    }
  };
  const responseGoogleError = (error) => {
    console.log("response take place===>Error", error);
  }

  const responseGoogle = (googleUser) => {
    console.log("response take place", googleUser);

    if (googleUser.profileObj) {
      let obj = {
        // image: googleUser.profileObj.imageUrl,
        name: googleUser.profileObj.name,
        // email: googleUser.profileObj.email,
        socialId: googleUser.profileObj.googleId,
        socialMediaType: "GOOGLE",
      };
      console.log("response take place", obj);
      AuthPostAxios(obj);
    }
  };
  string.setLanguage(lang);
  return (
    <div>
      <Modal
        style={{ direction: lang === "ar" ? "rtl" : "ltr" }}
        show={show}
        onHide={props.close}
        animation={false}
        className="AuthModal"
      >
        <Modal.Body className="p-0">
          <Container fluid>
            <Row className="justify-content-between authbody">
              <Col
                md="5"
                className="authlogo px-0"
                style={{
                  borderLeft: lang === "ar" ? "1px solid #EBEBEB" : "",
                  borderRight: lang === "en" ? "1px solid #EBEBEB" : "",
                  borderTopRightRadius:lang === "en" ? "":"10px",
                  borderBottomRightRadius:lang === "en" ? "":"10px",
                }}
              >
                <i
                  style={{
                    left: lang === "ar" ? "10px" : "",
                    right: lang === "en" ? "10px" : "",
                  }}
                  onClick={props.close}
                  className="fas fa-times closeBTNresponsive"
                >
                  {" "}
                </i>
                <div style={{ margin: "auto" }}>
                  <img
                    src={lang === "ar" ? originallogo1 : originallogo2}
                    alt="logo"
                  />
                </div>
              </Col>
              <Col
                md="7"
                className="px-0 fixcloseresponsive"
                style={{ paddingBottom: "40px", paddingTop: "50px" }}
              >
                <Field
                  dimButton={dimButton}
                  inputs={Inputs}
                  validation={Validation}
                  config={config}
                  SubmitBtnStyle={btnLoginStyle}
                />
                <i
                  style={{
                    left: lang === "ar" ? "10px" : "",
                    right: lang === "en" ? "10px" : "",
                  }}
                  onClick={props.close}
                  className="fas fa-times closeBTN"
                >
                  {" "}
                </i>
                <p className="forgetpassword mx-auto text-center">
                  <Link
                    to="#"
                    onClick={() => {
                      ToggleForm_forgetPass();
                      setShow(false);
                    }}
                  >
                    {string.forget}
                  </Link>
                </p>
                <hr className="forget-hr"></hr>
                <Link
                  to="#"
                  onClick={() => {
                    ToggleForm_signUp();
                    setShow(false);
                  }}
                  className="btn btn-block loginBtnStyle"
                  style={{ color: "#AE0A0A",fontSize:"18px",fontWeight:"600" }}
                >
                  {string.newaccount}
                </Link>
                <p className="text-center selectsocial">
                  {" "}
                  {string.socialselect}
                </p>
                <div className="text-center">
                  <div className="faceloginBtnStyle">
                    <FacebookLogin
                      appId="190558459332914"
                      fields="email,first_name,last_name,picture.type(large)"
                      callback={responseFacebook}
                      textButton=""
                      cssClass="my-facebook-button-class"
                      icon="fa-facebook"
                    />
                  </div>
                  <div className="googleloginBtnStyle">
                    <GoogleLogin
                      style={{ backgroundColor: "#F65353", boxShadow: "none" }}
                      clientId="644969845584-1hgeveu6ht38raefpmqkrc4mnsbrelpg.apps.googleusercontent.com"
                      buttonText=""
                      onSuccess={responseGoogle}
                      onFailure={responseGoogleError}
                    />
                  </div>
                </div>
                {/* <div className="registerBTN mt-3">
                                    <Link
                                        to="#"
                                        onClick={() => {
                                            ToggleForm_signUp()
                                            setShow(false)
                                        }} className="btn btn-block loginBtnStyle" >{string.newaccount}</Link>
                                </div> */}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
      {openFormSignUp && <SignUpForm close={ToggleForm_signUp} />}
      {openFormForgetPass && <ForgetPass close={ToggleForm_forgetPass} />}
    </div>
  );
};
export default Login;
